import ApiService from '../../../../../../services/ApiService'
import utils from '../../../../../../Utils/FormatDate'
import ManageSupplier from '../../../../Suppliers/components/ManageSupplier'
import AlienatedEquipment from '../../../templates/alienatedEquipmentTemplate.vue'
import ManageAlert from '../../../../Alert/components/manageAlert/ManageAlert.vue'
import AddScheduleEquipment from '../addScheduleEquipment/addScheduleEquipment.vue'
import InstitutionInactive from '../../../../Institutions/components/institutionInactive/institutionInactive.vue'
import DepartmentInactive from '../../../../Department/deparmentInactive/departmentInactive.vue'

export default {
  props: {
    equipmentId: String,
    institutionIdProp: String,
  },

  components: {
    ManageSupplier,
    AlienatedEquipment,
    ManageAlert,
    AddScheduleEquipment,
    InstitutionInactive,
    DepartmentInactive,
  },

  created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institutionIdProp
    this.workshopType = institution.workshopType
    this.institutionInactive = institution.status == 1
    window.scrollTo(0, 0)
    this.getUndiades()
    this.getStandardEquipment()
    this.getDepartments()
    this.getCostCenters()
    this.getContracts()
    this.getSuppliers()

    if (this.equipmentId) {
      this.getEquipment()
    }
  },

  data: () => ({
    errorMessage: '',
    criticality: '',
    criticalityValue: 0,
    menuPurchaseDate: false,
    menuDeliveryDate: false,
    menuWarrantyStartDate: false,
    menuInstallationEndDate: false,
    loading: false,
    unidadeLoading: false,
    standardEquipmentLoading: false,
    departmentLoading: false,
    costCenterLoading: false,
    contractLoading: false,
    supplierLoading: false,
    historicalLoading: false,
    deleteServiceOrderLoading: false,
    showHistorical: false,
    showSchedule: false,
    firstValid: true,
    alterDialog: false,
    alienatedDialog: false,
    supplierDialog: false,
    alertDialog: false,
    deleteServiceOrderDialog: false,
    scheduleDialog: false,
    dialogKey: false,
    changedData: false,
    isEditing: false,
    error: false,
    institutionInactive: false,
    departmentInactive: false,
    tab: null,
    purchaseDate: null,
    deliveryDate: null,
    warrantyStartDate: null,
    warrantyEndDate: null,
    installationEndDate: null,
    institutionId: null,
    functionEquipment: null,
    equipmentRisk: null,
    selectedDepartment: {},
    unidadeId: 0,
    unidades: [],
    standardEquipmentId: 0,
    standardEquipments: [],
    currentStandardEquipment: {},
    alert: {},
    departmentId: 0,
    departments: [],
    costCenterId: null,
    costCenters: [],
    contractId: null,
    contracts: [],
    supplierId: null,
    suppliers: [],
    historicalDepartment: [],
    expanded: [],
    expandedService: [],
    currentServiceOrder: {},
    equipmentSelected: [],
    serviceOrders: [],
    userType: null,
    mtbf: 0,
    workshopType: null,
    currentDepartment: {},
    situations: [
      'Aluguel',
      'Comodato',
      'De médico/Equipe',
      'Empréstimo',
      'Próprio',
      'Terceiros',
    ],
    voltages: [
      '110V',
      '220V',
      '110V / 220V - Bivolt',
      '220V Trifásico',
      '380V Trifásico',
      '440V',
      '480V',
      '13,8KV',
    ],
    degreeImportances: ['A', 'B', 'C'],
    functionsEquipment: [
      'Acessório',
      'Análise',
      'Diagnóstico',
      'Outros equipamentos de apoio',
      'Suporte à vida',
      'Terapia',
    ],
    equipmentRisks: [
      'Acessório',
      'Injuria',
      'Morte',
      'Sem risco',
      'Terapia ou diagnóstico inapropriado',
    ],
    serviceOrderTypes: [
      'Treinamento',
      'Segurança elétrica',
      'Preventiva',
      'Instalação',
      'Rotina de Inspeção',
      'Corretiva',
      'Calibração',
      'Validação/Qualificação',
    ],
    currentEquipment: {
      id: 0,
      name: '',
      propertyCode: '',
      manufacturer: '',
      location: '',
      model: '',
      serialNumber: '',
      voltage: null,
      candlePower: '',
      identification: '',
      contractValue: '',
      numberAnvisa: '',
      purchasePrice: '',
      purchaseDate: null,
      situation: null,
      degreeImportance: null,
      exchangeDay: '',
      warrantyTime: '',
      deliveryDate: null,
      warrantyStartDate: null,
      warrantyEndDate: null,
      installationEndDate: null,
      manuals: '',
      accessories: '',
      observation: '',
      alienated: false,
      criticality: 0,
      lifeExpectancy: 0,
      invoice: '',
    },
    unidadeRules: [(v) => !!v || 'Unidade requerida'],
    standardEquipmentRules: [(v) => !!v || 'Equipamento padrão requerido'],
    departmentRules: [(v) => !!v || 'Setor requerido'],
    costCenterRules: [(v) => !!v || 'Centro de custo requerido'],
    nameRules: [
      (v) => !!v || 'Equipamento requerido',
      (v) =>
        (v && v.length <= 128) ||
        'Equipamento deve ter no máximo 128 caracteres',
    ],
    manufacturerRules: [
      (v) => !!v || 'Fabricante requerido',
      (v) =>
        (v && v.length <= 128) ||
        'Fabricante deve ter no máximo 128 caracteres',
    ],
    modelRules: [
      (v) => !!v || 'Modelo requerido',
      (v) => (v && v.length <= 64) || 'Modelo deve ter no máximo 64 caracteres',
    ],
    serialNumberRules: [
      (v) => !!v || 'Nº de série requerido',
      (v) =>
        (v && v.length <= 25) || 'Nº de série deve ter no máximo 25 caracteres',
    ],
    situationRules: [(v) => v != -1 || 'Situação requerida'],
    propertyCodeRules: [
      (v) =>
        !v ||
        v.length <= 20 ||
        'Cód. patrimônio deve ter no máximo 20 caracteres',
    ],
    locationRules: [
      (v) =>
        !v || v.length <= 64 || 'Localização deve ter no máximo 64 caracteres',
    ],
    candlePowerRules: [
      (v) =>
        !v || v.length <= 10 || 'Potência deve ter no máximo 10 caracteres',
    ],
    invoiceRules: [
      (v) =>
        !v || v.length <= 10 || 'Nota fiscal deve ter no máximo 10 caracteres',
    ],
    numberAnvisaRules: [
      (v) =>
        !v ||
        v.length <= 20 ||
        'Número Anvisa deve ter no máximo 20 caracteres',
    ],
    headers: [
      {
        text: 'Unidade/Setor Origem',
        align: 'center',

        value: 'source',
        sortable: false,
      },
      {
        text: 'Unidade/Setor Destino',
        align: 'center',

        value: 'destiny',
        sortable: false,
      },
      {
        text: 'Data Migração',
        align: 'center',

        value: 'migretionDate',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Data Migração',
        align: 'center',

        value: 'migretionDate',
        sortable: false,
      },
    ],
    headersServiceOrder: [
      {
        text: 'Nome',
        align: 'center',

        value: 'name',
      },
      {
        text: 'Tipo',
        align: 'center',

        value: 'type',
      },
      {
        text: 'Data Agendamento',
        align: 'center',

        value: 'requestDate',
      },
      {
        text: 'Data Fechamento',
        align: 'center',

        value: 'closeDate',
      },
      {
        text: 'Ações',
        align: 'center',

        value: 'actions',
        sortable: false,
      },
    ],
    headersServiceOrderMobile: [
      {
        text: 'Nome',
        align: 'center',

        value: 'name',
        sortable: false,
      },
      {
        text: 'Ações',
        align: 'center',

        value: 'actions',
        sortable: false,
      },
    ],

    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      return this.isEditing ? 'Atualizar' : 'Adicionar'
    },
  },

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.push('/equipment')
      }
    },

    closeDialog() {
      if (this.supplierDialog) {
        this.supplierDialog = false
        this.getSuppliers()
      } else if (this.alienatedDialog) {
        this.alienatedDialog = false
        this.close()
      } else if (this.alertDialog) {
        this.alertDialog = false
      } else if (this.scheduleDialog) {
        this.scheduleDialog = false
        this.listServicesOrders()
      } else {
        this.changedData = false
        this.close()
      }
    },

    isNumber(value) {
      return typeof value === 'number'
    },

    addSupplier() {
      this.dialogKey = !this.dialogKey
      this.supplierDialog = true
    },

    openServiceOrder(serviceOrder) {
      const route = this.$router.resolve({
        path: `/bigData-editServiceOrder/${serviceOrder.id}/${serviceOrder.institutionId}`,
      })
      window.open(route.href, '_blank')
    },

    deleteServiceOrder(serviceOrder) {
      this.currentServiceOrder = serviceOrder
      this.deleteServiceOrderDialog = true
      this.dialogKey = !this.dialogKey
    },

    addSchedule() {
      this.equipmentSelected = []
      this.equipmentSelected.push(this.setEquipment())
      this.scheduleDialog = true
      this.dialogKey = !this.dialogKey
    },

    showSuccess(message) {
      this.$emit('show', message)
    },

    createAlert() {
      this.alert = {
        description: `Fim da garantia do Equipamento - ${this.currentEquipment.name}`,
        eventDate: utils.nowDatetimeFormat(
          this.parseDate(this.warrantyEndDate)
        ),
        alertModule: 1,
        equipmentId: this.currentEquipment.id,
      }

      this.dialogKey = !this.dialogKey
      this.alertDialog = true
    },

    alienateEquipment() {
      this.dialogKey = !this.dialogKey
      this.alienatedDialog = true
      this.changedData = false
    },

    selectedStandardEquipment() {
      this.currentStandardEquipment = this.standardEquipments.find(
        (standardEquip) =>
          standardEquip.standardEquipmentId === this.standardEquipmentId
      )

      if (
        this.isNumber(
          this.currentStandardEquipment.standardEquipment.functionEquipment
        ) &&
        this.isNumber(
          this.currentStandardEquipment.standardEquipment.equipmentRisk
        )
      ) {
        this.functionEquipment =
          this.functionsEquipment[
            this.currentStandardEquipment.standardEquipment.functionEquipment
          ]
        this.equipmentRisk =
          this.equipmentRisks[
            this.currentStandardEquipment.standardEquipment.equipmentRisk
          ]
      }

      this.currentEquipment.degreeImportance =
        this.currentStandardEquipment.standardEquipment.indexAbc
      this.currentEquipment.lifeExpectancy =
        this.currentStandardEquipment.standardEquipment.lifeExpectancy
      this.currentEquipment.name =
        this.currentStandardEquipment.standardEquipment.name

      this.calculateCriticality()
    },

    calculateCriticality() {
      let functionScore = 0
      let riskScore = 0
      let indexAbcScore = 0

      switch (this.functionEquipment) {
        case 'Suporte à vida':
          functionScore = 10
          break
        case 'Terapia':
          functionScore = 8
          break
        case 'Diagnóstico':
          functionScore = 6
          break
        case 'Análise':
          functionScore = 4
          break
        case 'Outros equipamentos de apoio':
          functionScore = 2
          break
        default:
          functionScore = 0
          break
      }

      switch (this.equipmentRisk) {
        case 'Morte':
          riskScore = 7
          break
        case 'Injuria':
          riskScore = 5
          break
        case 'Terapia ou diagnóstico inapropriado':
          riskScore = 3
          break
        case 'Sem risco':
          riskScore = 1
          break
        default:
          riskScore = 0
          break
      }

      switch (this.currentEquipment.degreeImportance) {
        case 'A':
          indexAbcScore = 10
          break
        case 'B':
          indexAbcScore = 5
          break
        default:
          indexAbcScore = 0
          break
      }

      this.criticalityValue = functionScore + riskScore + indexAbcScore

      if (this.criticalityValue >= 19 && this.criticalityValue <= 27) {
        this.criticality = 'Alta'
      } else if (this.criticalityValue >= 12 && this.criticalityValue <= 18) {
        this.criticality = 'Média'
      } else if (this.criticalityValue >= 3 && this.criticalityValue <= 11) {
        this.criticality = 'Baixa'
      } else {
        this.criticality = '--'
      }
    },

    selectedCostCenter() {
      const costCenter = this.costCenters.find(
        (x) => x.departmentId === this.departmentId
      )
      if (costCenter && this.costCenterId == null) {
        this.costCenterId = costCenter.id
      }
    },

    async getEquipment() {
      await this.apiService
        .get(`equipment/${this.institutionId}/${this.equipmentId}`)
        .then((response) => {
          this.currentEquipment = response.content
          this.unidadeId = response.content.unidadeId
          this.standardEquipmentId = response.content.standardEquipmentId
          this.currentStandardEquipment = response.content.standardEquipment
          this.departmentId = response.content.departmentId

          if (response.content.costCenterId != null) {
            this.costCenterId = response.content.costCenterId
          } else {
            this.selectedCostCenter()
          }

          this.contractId = response.content.contractId
          this.supplierId = response.content.supplierId
          this.currentEquipment.voltage =
            this.voltages[response.content.voltage]
          this.currentEquipment.situation =
            this.situations[response.content.equipmentAcquisitionSituation]
          this.currentEquipment.contractValue =
            response.content.contractValue == 0
              ? ''
              : response.content.contractValue
          this.currentEquipment.exchangeDay =
            response.content.exchangeDay == 0
              ? ''
              : response.content.exchangeDay
          this.currentEquipment.purchasePrice =
            response.content.purchasePrice == 0
              ? ''
              : response.content.purchasePrice

          this.purchaseDate = this.formatInitialDate(
            response.content.purchaseDate
          )
          this.deliveryDate = this.formatInitialDate(
            response.content.deliveryDate
          )

          this.warrantyStartDate = this.formatInitialDate(
            response.content.warrantyStartDate
          )
          this.installationEndDate = this.formatInitialDate(
            response.content.installationEndDate
          )

          this.warrantyEndDate = this.formatInitialDate(
            response.content.warrantyEndDate
          )

          this.functionEquipment =
            this.functionsEquipment[
              response.content.standardEquipment.functionEquipment
            ]
          this.equipmentRisk =
            this.equipmentRisks[
              response.content.standardEquipment.equipmentRisk
            ]

          this.departmentInactive = response.content.department.status == 1
          this.currentEquipment.invoice = response.content.invoice
          this.calculateCriticality()

          this.getMtbf()
          this.getDepartmentHistorical()
          this.listServicesOrders()

          this.isEditing = true
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          if (err.status === 404) {
            this.$router.push('/equipment')
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getDepartmentHistorical() {
      this.historicalLoading = true
      await this.apiService
        .get(`equipment/departmentHistorical/${this.currentEquipment.id}`)
        .then((response) => {
          this.historicalDepartment = response.content

          this.showHistorical = this.historicalDepartment.length > 0
        })
      this.historicalLoading = false
    },

    async getUndiades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.unidadeLoading = false
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      await this.apiService
        .get(`standardEquipment/list/${this.institutionId}`)
        .then((response) => {
          this.standardEquipments = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.standardEquipmentLoading = false
    },

    async getDepartments() {
      this.departmentLoading = true
      await this.apiService
        .get(`department/listActive/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.departmentLoading = false
    },

    async getCostCenters() {
      this.costCenterLoading = true

      await this.apiService
        .get(`costCenter/listActive/${this.institutionId}`)
        .then((response) => {
          this.costCenters = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.costCenterLoading = false
    },

    async getContracts() {
      this.contractLoading = true

      await this.apiService
        .get(`contract/list/${this.institutionId}`)
        .then((response) => {
          this.contracts = response.content
          this.contracts.unshift({
            id: 0,
            name: '',
            number: '',
          })
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.contractLoading = false
    },

    async getSuppliers() {
      ;(this.supplierLoading = true),
        await this.apiService
          .get(`supplier/list/${this.institutionId}`)
          .then((response) => {
            this.suppliers = response.content
            this.suppliers.unshift({
              id: 0,
              name: '',
            })
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })

      this.supplierLoading = false
    },

    async listServicesOrders() {
      await this.apiService
        .get(`serviceOrder/list/${this.currentEquipment.id}`)
        .then((response) => {
          this.serviceOrders = response.content
          this.showSchedule = response.content.length > 0
        })
    },

    async remove() {
      this.deleteServiceOrderLoading = true
      const user = JSON.parse(localStorage.getItem('user'))
      const model = {
        serviceOrderId: serviceOrderId,
        archivedByuserId: user.id,
      }

      await this.apiService
        .delete(`serviceOrder/delete`, model)
        .then(() => {
          this.deleteServiceOrderDialog = false
          this.listServicesOrders()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.deleteServiceOrderLoading = false
      this.deleteServiceOrderDialog = false
    },

    async getMtbf() {
      await this.apiService
        .get(`equipment/mtbf/${this.currentEquipment.id}`)
        .then((response) => {
          this.mtbf = response.content
        })
    },

    async submit() {
      if (this.$refs.firstForm.validate()) {
        this.loading = true

        let url = 'equipment/add'

        if (this.isEditing) {
          url = 'equipment/edit'
        }

        await this.apiService
          .post(url, this.setEquipment())
          .then(() => {
            this.closeDialog()
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })

        this.loading = false
        this.changedData = false
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
    },

    formatDate(date) {
      return utils.moment(date)
    },

    formatDateTime(date) {
      return utils.dateTime(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      if (!dateInitial) return null
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    save(date) {
      this.purchaseDate = this.formatInputDate(
        this.currentEquipment.purchaseDate
      )
      this.$refs.menuPurchaseDate.save(date)

      this.deliveryDate = this.formatInputDate(
        this.currentEquipment.deliveryDate
      )
      this.$refs.menuDeliveryDate.save(date)

      this.warrantyStartDate = this.formatInputDate(
        this.currentEquipment.warrantyStartDate
      )
      this.$refs.menuWarrantyStartDate.save(date)

      this.installationEndDate = this.formatInputDate(
        this.currentEquipment.installationEndDate
      )
      this.$refs.menuInstallationEndDate.save(date)

      this.calculateWarrantyEndDate()
    },

    calculateWarrantyEndDate() {
      if (
        this.warrantyStartDate != null &&
        this.currentEquipment.warrantyTime != ''
      ) {
        this.warrantyEndDate = utils.moment(
          utils.addMonths(
            this.warrantyStartDate,
            this.currentEquipment.warrantyTime
          )
        )
      } else {
        this.warrantyEndDate = ''
      }
    },

    setEquipment() {
      const equipment = {
        Id: this.currentEquipment.id,
        InstitutionId: this.institutionId,
        UnidadeId: this.unidadeId,
        StandardEquipmentId: this.standardEquipmentId,
        DepartmentId: this.departmentId,
        CostCenterId: this.costCenterId,
        Name: this.currentEquipment.name,
        PropertyCode: this.currentEquipment.propertyCode,
        Manufacturer: this.currentEquipment.manufacturer,
        Location: this.currentEquipment.location,
        Model: this.currentEquipment.model,
        SerialNumber: this.currentEquipment.serialNumber,
        Voltage: this.voltages.indexOf(this.currentEquipment.voltage),
        CandlePower: this.currentEquipment.candlePower,
        Identification: this.currentEquipment.identification,
        ContractId: this.contractId == 0 ? null : this.contractId,
        ContractValue:
          this.currentEquipment.contractValue != ''
            ? this.currentEquipment.contractValue
            : 0,
        NumberAnvisa: this.currentEquipment.numberAnvisa,
        SupplierId: this.supplierId < 1 ? null : this.supplierId,
        PurchasePrice:
          this.currentEquipment.purchasePrice != ''
            ? this.currentEquipment.purchasePrice
            : 0,
        PurchaseDate: this.currentEquipment.purchaseDate,
        EquipmentAcquisitionSituation: this.situations.indexOf(
          this.currentEquipment.situation
        ),
        DegreeImportance: this.currentEquipment.degreeImportance,
        ExchangeDay:
          this.currentEquipment.exchangeDay != ''
            ? this.currentEquipment.exchangeDay
            : 0,
        WarrantyTime: this.currentEquipment.warrantyTime,
        DeliveryDate: this.currentEquipment.deliveryDate,
        WarrantyStartDate: this.currentEquipment.warrantyStartDate,
        WarrantyEndDate: this.parseDate(this.warrantyEndDate),
        InstallationEndDate: this.currentEquipment.installationEndDate,
        Manuals: this.currentEquipment.manuals,
        Accessories: this.currentEquipment.accessories,
        Observation: this.currentEquipment.observation,
        Criticality: this.criticalityValue,
        LifeExpectancy: this.currentEquipment.lifeExpectancy,
        Invoice: this.currentEquipment.invoice,
        Alienated: this.currentEquipment.alienated,
      }

      return equipment
    },
  },

  watch: {
    currentEquipment: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
